export default __webpack_public_path__ + "locales/sl/Common.json?hash=cd14c2a11923bb34c4c54e87f50f998c";